export default "/_next/static/hero.jpg";